import React from "react";
import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { BannerManagementPresentation } from "./components/BannerManagementPresentation";

export const BannerManagementPage: React.FC = () => {
    return (
        <AuthGuard>
            <Sidebar>
                <BannerManagementPresentation />
            </Sidebar>
        </AuthGuard>
    );
};
